<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head.head-border
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
        el-col.pt-5.text-right(:span="15")
          div.fr.ml-3
            el-button(v-if="true" type="primary" size="mini" @click="goBack") 返回
          div.fr.ml-3
            el-upload.fr(:action="path" :before-upload="beforeUpload" :data="getPk" :on-success="handleSuccess" :show-file-list="false" :headers="http_header")
              el-button(size="mini" type="primary" :loading="loading") 数据导入
          div.fr.ml-3
            //el-button(v-if="true" type="primary" size="mini" @click="") 模版下载
            el-button(type="primary" size="mini" @click="download(url+'/serverdata/file/%E7%BB%9F%E8%B0%88%E5%88%86%E7%AD%BE%E6%A8%A1%E7%89%88%E4%B8%8B%E8%BD%BD.xlsx')") 模版下载
          div.fr.ml-3
            el-button(v-if="user.role == 3 ? true : ops.indexOf('export') > -1" type="primary" size="mini" :loading="loading" @click="exportData") 导出
          div.fr
            el-button(v-if="true" type="primary" size="mini" @click="handleDelete") 删除  
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      div
        el-row.py-3(type="flex" justify="center")
          el-col(:span="22")
            el-row(type="flex" justify="center" :gutter="10")
              el-col(:span="6")
                el-select.w-100(v-model="list.pk_org" filterable placeholder="请选择组织" clearable)
                  el-option(v-for="item in purchase_org" :key="item.pk_org" :label="item.name" :value="item.pk_org")    
              el-col(:span="6")
                el-input.w-100(v-model="list.name_material" placeholder="物料名称" clearable)
              el-col(:span="6")
                el-input.w-100(v-model="list.code_material" placeholder="物料编码" clearable)
        el-row.py-1(type="flex" justify="center")
          el-col(:span="12")
            el-row(type="flex" justify="center")
              el-col(:span="10")
                el-button(type="primary" @click="search" :loading="loading") 查询
                el-button(@click="clear") 清空
      el-table(:data="data" v-loading="loading" row-key="id" size="mini" @selection-change="handleSelectionChange" tooltip-effect="dark")
        el-table-column(type="selection" width="50" key="selection")
        el-table-column(prop="name_supplier" label="供应商")
        el-table-column(prop="name_org" label="采购组织")
        el-table-column(prop="code_material" label="物料编码" width="150")
        el-table-column(prop="name_material" label="物料名称" width="220")
        el-table-column(prop="weight" label="毛坯重量（kg）"  width="120")
        el-table-column(prop="latest_price2" label="单品基准价" width="100")
        el-table-column(prop="create_date" label="创建时间" width="150")
        el-table-column(label="操作" width="100")
          template(slot-scope="scope")
            el-button(size="mini" type="primary" plain @click="go('/admin/price_data_detail_record/'+scope.row.id)") 查看
      el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total, sizes, prev, pager, next, jumper" :total="count" background)
</template>
<script>
import { url } from "@/utils/config";
export default {
  data() {
    return {
      url: url,
      h: "",
      title: "新增",
      loading: false,
      data: [],
      dialogFormVisible: false,
      count: 0,
      list: {
        pk_guide: "",
        page_num: 1,
        page_size: 10,
      },
      loadingSupply: false,
      path: this.$api.pricedata.import_file,
      supply: [],
      disabled: false,
      multipleSelection: [],
    };
  },
  computed: {
    getPk() {
      return { pk_guide: this.id };
    },
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    type: {
      type: [Number, String],
      default: 1,
    },
  },
  methods: {
    goBack() {
      //localStorage.removeItem("PriceData_page_num");
      let page_num = localStorage.getItem("PriceData_page_num");
      if (parseInt(page_num)) {
        this.$router.push({
          path: "/admin/price_data",
          query: { page_num: page_num },
        });
      } else {
        this.$router.push("/admin/price_data");
      }
    },
    go(path) {
      localStorage.setItem("PriceDataEdit_page_num", this.list.page_num);
      localStorage.setItem("PriceDataEdit_id", this.id);
      this.$router.push(path);
    },
    search() {
      this.list.page_num = 1;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    clear() {
      this.list.pk_org = null;
      this.list.name_material = null;
      this.list.code_material = null;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        query: this.list,
      });
    },
    beforeUpload() {
      this.loading = true;
      return true;
    },
    handleSuccess(res) {
      this.loading = false;
      if (res.code == 200) {
        this.getList();
      } else {
        this.$notify({
          message: res.msg,
          type: "error",
        });
      }
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        query: this.list,
      });
    },
    async getList() {
      this.loading = true;
      let res = await this.$api.pricedata.getPriceList(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count = res.count;
      }
    },
    init() {
      let data = this.$route.query;
      if (data) {
        this.list = this.$utils.cloneDeep(data);
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
      }
      this.getList();
    },
    handleDelete() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }

      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let data = [];
          for (var i in this.multipleSelection) {
            data.push(this.multipleSelection[i].id);
          }
          let res = await this.$api.pricedata.delEdit(data.toString());
          this.loading = false;
          if (res) {
            this.getList();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        })
        .catch(() => {});
    },
    async exportData() {
      this.loading = true;
      await this.$api.pricedata.getBlob(this.list, "价格信息");
      this.loading = false;
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    this.list.pk_guide = this.id;
    this.getList();
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseOrg();
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>